import React from 'react';
import { Helmet } from 'react-helmet';
import Container from 'react-bootstrap/Container';
import Article from '../../components/Article/Article';

// import Iframe from 'react-iframe';
// import ResponsiveEmbed from 'react-responsive-embed';

import classes from './About.css';

class About extends React.Component{

    render(){

        return (
            <div className={classes.About}>
                <Helmet>
                    <title>About | BookMeeY</title>
                    <meta name="description" content="Who we are, the story and motivation behind BookMeeY, and how to reach out to us." />
                </Helmet>

                <Container>
                    {/* <Row>
                        <Col lg={{ span: 8, offset: 2 }}>
                        <div className={classes.Video}>
                        <ResponsiveEmbed src='https://player.vimeo.com/video/419802169?autoplay=1&loop=1&autopause=0' allow="autoplay; fullscreen" allowFullScreen />
                        </div>
                        </Col>
                    </Row> */}
                    <Article
                        header="What is BookMeeY"
                        bodys={[
                            "BookMeeY is a social solution to make maintaining meaningful connections simple.",
                        ]}
                    ></Article>
                    <Article 
                        header="Our Mission"
                        bodys={[
                            "Preserve and maintain real human connections in a digitally connected world."
                        ]}
                    ></Article>
                    <Article
                        header="How BookMeeY Works"
                        bodys={[
                            "1. Create a calendar for your friends to book.",
                            "2. Share your calendar link on your social media.", 
                            "3. Catch up with your friend at the scheduled time.",
                            "4. Follow up with your friends to connect again in the future."
                        ]}
                    ></Article>
                    <Article
                        header="What BookMeeY Provides"
                        bodys={[
                            "BookMeeY provides a few critical features.",
                            "1. It provides a calendar you can share on social media, so you can have your friends book a chat with you without the awkwardness of asking.",
                            "2. It allows you to add a note for everyone who clicks your calendar, to tell them what you want to chat about, or just some recent news you want to share. This acts as an icebreaker, to make it easier to start a conversation.",
                            "3. A connection maintenance system, which will auto remind both you and your friends to catch up after a certain time from the last conversation."
                        ]}
                    ></Article>
                    <Article
                        header="What BookMeeY is NOT"
                        bodys={[
                            "BookMeeY is not just another calendar solution. It is a social solution to maintain meaningful connections with everyone in your life. In order to achieve this, there are many steps needed to be done, but we believe, the first step is to start calling friends on the phone and have a good conversation."
                        ]}
                    ></Article>
                    <Article
                        header="Host vs. Guest"
                        bodys={[
                            "A host is a person who posts the BookMeeY page for friends to book. The host is expected to take the initiative, both for actively sharing his/her BookMeeY calendar, and reach out to guests during the appointment time.",
                            "A guest is a person who books a call using a friend’s BookMeeY page, as a guest, you’ll enjoy a good conversation."
                        
                        ]}
                    ></Article>
                </Container>

            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/containers/About/About.js